<template>
  <section>
    <div class="content_bg">
      <div class="content">
        <div class="caption_wrap">
          <CaptionGray label="함께한 기업들"></CaptionGray>
        </div>
        <div class="logos">
          <div class="logo_item" v-for="company in companies" :key="company.name">
            <img
              :src="company.img"
              :alt="company.name"
              class="logo_img"
              :style="company.height ? { maxHeight: company.height, maxWidth: 'none' } : {}"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import CaptionGray from "./CaptionGray.vue";
export default {
  components: { CaptionGray },
  data() {
    return {
      companies: [
        { name: "현대오토에버", img: "/reference_logo/hyundai_auto.svg" },
        { name: "현대제철", img: "/reference_logo/hyundai_steel.jpg", height: "46px"  },
        { name: "에어부산", img: "/reference_logo/airbusan.png" },
        { name: "신한은행", img: "/reference_logo/sinhan.svg" },
        { name: "KICT", img: "/reference_logo/kict.png", height: "92px" },
        { name: "대구한의대", img: "/reference_logo/degu.png" , height: "60px"},
        { name: "AAMP Global", img: "/reference_logo/aamp.jpg", height: "32px" },
      ],
    };
  },
};
</script>

<style scoped>
.content_bg {
  display: flex;
  justify-content: center;
  width: 100vw;
  background-color: #ffffff;
  padding: 50px 20px 60px 20px;
  border-top: 1px solid #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
}

.content {
  width: 1140px;
  max-width: 1140px;
  text-align: center;
  padding: 60px 0;
}

.caption_wrap {
  margin-bottom: 64px;
}

.logos {
  margin-top: 32px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px 24px;
}

.logo_item {
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.45;
  transition: opacity 0.2s ease;
}

.logo_item:hover {
  opacity: 0.75;
}

.logo_img {
  max-height: 36px;
  max-width: 140px;
  object-fit: contain;
  filter: grayscale(100%);
}

.logo_text {
  font-size: 17px;
  font-weight: 700;
  color: #343a40;
  letter-spacing: -0.5px;
  white-space: nowrap;
}

@media screen and (max-width: 768px) {
  .logos {
    grid-template-columns: repeat(2, 1fr);
    gap: 36px 20px;
  }
}
</style>
